var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSql01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1499",
    d: "M22.4,27.5c0-2-1.6-3.7-3.7-3.7h-1.5c-2,0-3.7,1.6-3.7,3.7v4.4c0,2,1.6,3.7,3.7,3.7h1.5 c0.5,0,0.9-0.1,1.4-0.3c0.6,0.5,1.5,0.3,2-0.3c0.4-0.5,0.4-1.2,0-1.7c0.2-0.4,0.3-0.9,0.3-1.4V27.5z M16.5,31.9v-4.4 c0-0.4,0.3-0.7,0.7-0.7h1.5c0.4,0,0.7,0.3,0.7,0.7v3.1c-0.7-0.4-1.5-0.2-2,0.5c-0.3,0.5-0.3,1,0,1.5h-0.2 C16.9,32.6,16.5,32.3,16.5,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1500",
    d: "M31.2,35.5h-4.4c-0.8,0-1.5-0.7-1.5-1.5v-8.8c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v7.3h2.9 c0.8,0,1.5,0.7,1.5,1.5S32,35.5,31.2,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1501",
    d: "M7,35.5H4.8c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5H7c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7 c-2,0-3.7-1.6-3.7-3.7S5,23.8,7,23.8h2.2c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5H7c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7c2,0,3.7,1.6,3.7,3.7C10.7,33.9,9.1,35.5,7,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1502",
    d: "M28.2,15.8v5.4c-0.5-0.2-1-0.3-1.5-0.3c-1.4,0-2.7,0.7-3.5,1.8c-1.2-1.2-2.8-1.8-4.5-1.8h-1.5 c-1.7,0-3.3,0.7-4.5,1.8c-0.8-1.1-2.1-1.8-3.5-1.8H7.8v-5.1c0,3.6,9.2,3.7,10.2,3.7S28.2,19.4,28.2,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1503",
    d: "M28.2,12.9c0,3.6-9.2,3.7-10.2,3.7S7.8,16.4,7.8,12.9V7c0,3.6,9.2,3.7,10.2,3.7S28.2,10.6,28.2,7V12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1504",
    d: "M18,0.5c-1.1,0-10.2,0.1-10.2,3.7S16.9,7.8,18,7.8s10.2-0.1,10.2-3.7S19.1,0.5,18,0.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSql01);
export default __webpack_public_path__ + "static/media/ico-sql-01.38507a8c089b9be94832b49a8f9bb4f9.svg";
export { ForwardRef as ReactComponent };